module.exports = __webpack_public_path__ + "img/arrow-next.ea8022ba.svg";